import { render, staticRenderFns } from "./ChangeMenu.vue?vue&type=template&id=5d648ec7&scoped=true"
import script from "./ChangeMenu.vue?vue&type=script&lang=js"
export * from "./ChangeMenu.vue?vue&type=script&lang=js"
import style0 from "./ChangeMenu.vue?vue&type=style&index=0&id=5d648ec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d648ec7",
  null
  
)

export default component.exports